/** Static ornament paths under `src/assets/images/ornaments/`. */
export const ORNAMENT_ASSETS = {
  error: "assets/images/ornaments/error.png",
  noClaimsCases: "assets/images/ornaments/NoClaims-Cases.png",
  searchClaims: "assets/images/ornaments/search-claims.png",
  dashboardAlternative: "assets/images/ornaments/dashboard-alternative-content.png",
  storeAlternative: "assets/images/ornaments/store-alternative-content.png",
  onboardingModal: "assets/images/ornaments/onboarding-modal.png",
} as const;
